// extracted by mini-css-extract-plugin
export var container = "_ci-0";
export var popoverContent = "_ci-1";
export var tosLink = "_ci-2";